module.exports = __webpack_public_path__ + "img/profTran.d29d25d0.svg";